module.exports = __webpack_public_path__ + "img/icon-dimmer-dmx.6b6ebf5a.svg";